import { UserCommonService } from './../../services/user-common.service';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { ErrorBindingService } from '../../services/error-binding.service';
import { AppSettings } from '../../../shared/app.settings';


@Component({
    selector: 'app-otp-verifiy',
    templateUrl: './otp-verifiy.component.html',
    standalone: false
})
export class OtpVerifiyComponent implements OnInit, OnDestroy {
  @Input() email;
  @Input() phone;


  @Output() onOtpPopClose: EventEmitter<any> = new EventEmitter();
  @Output() onOtpPopSave: EventEmitter<any> = new EventEmitter();

  otpForm = new UntypedFormGroup({
    otpInput: new UntypedFormControl()
  });
  countdownDisplay = '';
  isResendDisabled = true;
  isResendProcessing = false;
  private readonly resendTimerDuration = 10;
  private remainingSeconds = 0;
  private countdownSubscription: Subscription | null = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private commonServices: UserCommonService,
    private errorBindingService: ErrorBindingService
  ) { }


  ngOnInit() {
    this.otpForm = this.formBuilder.group({
      otpInput: ['', [Validators.required]],
    });
    this.startCountdownTimer();
  }

  ngOnDestroy() {
    this.clearCountdownTimer();
  }

  closeEditForgot(event) {
    this.otpForm.reset();
    this.clearCountdownTimer();
    this.onOtpPopClose.emit();
  }

  changePassword(event) {
    let input;
    const otpInput = this.otpForm.controls.otpInput.value;
    input = {
      otp: otpInput,
      email: this.email
    };

    this.commonServices.validateOtp(JSON.stringify(input)).subscribe(results => {
      this.onOtpPopSave.emit(results);
      this.otpForm.reset();
    }, (error) => {
      this.dispalyMessage(error, 'error');
    });
  }

  resendOtp(event) {
    event.preventDefault();
    if (this.isResendDisabled || this.isResendProcessing) {
      return;
    }

    let input = null;
    if (this.email) {
      input = {
        email: this.email,
        tenantId: AppSettings.TENANT
      };
    } else if (this.phone) {
      input = {
        phoneNum: this.phone,
        tenantId: AppSettings.TENANT
      };
    }

    if (!input) {
      return;
    }

    this.isResendProcessing = true;
    this.commonServices.resendOTP(JSON.stringify(input)).subscribe(results => {
      this.dispalyMessage(results, 'success');
      this.restartTimer();
    }, (error) => {
      this.dispalyMessage(error, 'error');
      this.isResendProcessing = false;
    });
  }

  dispalyMessage(msgObj, msgType) {
    const hasDetail = msgObj && msgObj.general && msgObj.general[0];
    const detail = hasDetail ? msgObj.general[0].message : '';
    const summary = msgType === 'success' ? 'Success' : 'Error';
    this.errorBindingService.setMessage({
      severity: msgType,
      summary: summary,
      detail: detail
    });
  }

  private restartTimer() {
    this.isResendProcessing = false;
    this.startCountdownTimer();
  }

  private startCountdownTimer() {
    this.remainingSeconds = this.resendTimerDuration;
    this.isResendDisabled = true;
    this.updateCountdownDisplay();
    this.clearCountdownTimer();

    this.countdownSubscription = interval(1000).subscribe(() => {
      this.remainingSeconds = this.remainingSeconds - 1;
      if (this.remainingSeconds > 0) {
        this.updateCountdownDisplay();
      } else {
        this.isResendDisabled = false;
        this.updateCountdownDisplay(true);
        this.clearCountdownTimer();
      }
    });
  }

  private clearCountdownTimer() {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
      this.countdownSubscription = null;
    }
  }

  private updateCountdownDisplay(forceZero: boolean = false) {
    const seconds = forceZero ? 0 : Math.max(this.remainingSeconds, 0);
    const minutesPart = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secondsPart = (seconds % 60).toString().padStart(2, '0');
    this.countdownDisplay = `${minutesPart}:${secondsPart}`;
  }

}
